<template>
  <div>
    <a-card>
      <a-form layout="inline" ref="searchForm" :model="form.searchForm" style="margin-bottom: 20px;">
        <a-form-item label="任务类型" name="takType">
          <a-select
            style="width: 140px"
            v-model:value="form.searchForm.takType"
            :options="optData.taskTypeOpt"
          >
          </a-select>
        </a-form-item>
        <a-form-item label="总任务状态" name="status">
          <a-select
            style="width: 140px"
            v-model:value="form.searchForm.status"
            :options="optData.taskStatusOpt"
          >
          </a-select>
        </a-form-item>
        <a-form-item label="关键字" name="keywords">
          <a-input style="width: 200px" ref="keywords" placeholder="根据总任务编号/名称查询" v-model:value="form.searchForm.keywords" autocomplete="off">
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="search">查询</a-button>
        </a-form-item>
      </a-form>
      <a-table :dataSource="task.list" :columns="columns" :pagination="false">
        <template v-slot:taskType="{ record }">
          <div v-if="record.isParent">  <!-- 总任务 -->
            {{ statusTrans(record.type, taskType) }}
          </div>
        </template>
        <template v-slot:taskStatus="{ record }">
          <div v-if="record.isParent">  <!-- 总任务 -->                              
            {{ statusTrans(record.state, taskSatus) }}
          </div>
          <div v-else>  <!-- 子任务 -->
            {{ statusTrans(record.state, subtaskSatus) }}
          </div>
        </template>
        <template v-slot:action="{ record }">
          <div v-if="record.isParent">  <!-- 总任务 -->
            <div v-if="record.type == 'box3d' || record.type == 'video' || record.type == 'other'">
              <div v-if="record.state == 'to_be_received'">  <!-- 待接收 -->
                <span class="gap-btn">
                  <a @click="openDetail(record)">查看</a>
                </span>
                <span class="gap-btn">
                  <a-popconfirm
                    title="确认接收任务?"
                    @confirm="taskReceive(record)"
                  >
                    <a href="#">接收</a>
                  </a-popconfirm>  
                </span>
                <span class="gap-btn">
                  <a @click="rejectHandle(record)">拒绝</a>
                </span>
              </div>
              <div v-if="record.state == 'to_be_split'">  <!-- 待拆分 -->
                <span class="gap-btn">
                  <a @click="openDetail(record)">查看</a>
                </span>
                <!-- <span class="gap-btn" v-if="record.labelType == 'online'">
                  <a @click="splitHandle(record)">拆分</a>
                </span> -->
              </div>
              <div v-if="record.state == 'in_progress'">  <!-- 进行中 -->
                <span class="gap-btn">
                  <a @click="openDetail(record)">查看</a>
                </span>
                <!-- <span class="gap-btn">
                  <a @click="openDetail(record)">上传</a>
                </span> -->
                <span class="gap-btn">
                  <a-popconfirm
                    title="确认接收任务?"
                    @confirm="labelFinished(record)"
                  >
                    <a href="#">标注完成</a>
                  </a-popconfirm>  
                </span>
  
              </div>
              <div v-if="record.state == 'label_completed'">  <!-- 标注完成 -->
                <span class="gap-btn">
                  <a @click="openDetail(record)">查看</a>
                </span>
              </div>
              <div v-if="record.state == 'acceptance_completed' || record.state == 'rejected' || record.state == 'completed' || record.state == 'terminated'"> <!-- 初验完成 已拒绝  已完成  已终止  -->
                <span class="gap-btn">
                  <a @click="openDetail(record)">查看</a>
                </span>
              </div>
            </div>
            <div v-else>
              <div v-if="record.state == 'to_be_received'">  <!-- 待接收 -->
                <span class="gap-btn">
                  <a @click="openDetail(record)">查看</a>
                </span>
                <span class="gap-btn">
                  <a-popconfirm
                    title="确认接收任务?"
                    @confirm="taskReceive(record)"
                  >
                    <a href="#">接收</a>
                  </a-popconfirm>  
                </span>
                <span class="gap-btn">
                  <a @click="rejectHandle(record)">拒绝</a>
                </span>
              </div>
              <div v-if="record.state == 'to_be_split'">  <!-- 待拆分 -->
                <span class="gap-btn">
                  <a @click="openDetail(record)">查看</a>
                </span>
                <span class="gap-btn" v-if="record.labelType == 'online'">
                  <a @click="splitHandle(record)">拆分</a>
                </span>
              </div>
              <div v-if="record.state == 'in_progress'">  <!-- 进行中 -->
                <span class="gap-btn">
                  <a @click="openDetail(record)">查看</a>
                </span>
                <span class="gap-btn"  v-if="record.labelType == 'online'">
                  <a @click="splitHandle(record)">重新拆分</a>
                </span>
              </div>
              <div v-if="record.state == 'acceptance_completed' || record.state == 'rejected' || record.state == 'completed' || record.state == 'terminated'"> <!-- 初验完成 已拒绝  已完成  已终止  -->
                <span class="gap-btn">
                  <a @click="openDetail(record)">查看</a>
                </span>
              </div>
            </div>
            
          </div>
          <div v-else>  <!-- 子任务 -->
            <div v-if="record.labelType == 'online'">
              <span class="gap-btn"  v-if="record.state == 'to_be_assigned'"> <!--  待指派   -->
                <a @click="taskAssignHandle(record)">指派</a>
              </span>
              <span class="gap-btn" v-if="record.state == 'to_be_labeled' || record.state == 'in_labeling' || record.state == 'to_be_inspected' || record.state == 'in_inspecting'"> <!--  待标注  待标注  待质检  质检中  -->
                <a @click="taskAssignHandle(record)">重新指派</a>
              </span>
          
              <span class="gap-btn"  v-if="record.state == 'to_be_submitted'"> <!--  待提交   -->
                <a @click="taskSubmit(record)">提交</a>
              </span>
          
              <span class="gap-btn">
                <a @click="openSubDetail(record)">查看</a>
              </span>
            
            </div>

            <div v-if="record.labelType == 'offline'">
              <span class="gap-btn"  v-if="record.state == 'to_be_assigned'"> <!--  待指派   -->
                <a @click="taskAssignHandle(record)">指派</a>
              </span>
              <span class="gap-btn" v-if="record.state == 'to_be_labeled' || record.state == 'in_labeling' || record.state == 'to_be_inspected' || record.state == 'in_inspecting'"> <!--  待标注  待标注  待质检  质检中  -->
                <a @click="taskAssignHandle(record)">重新指派</a>
              </span>
          
              <span class="gap-btn"  v-if="record.state == 'to_be_submitted'"> <!--  待提交   -->
                <a @click="taskSubmit(record)">提交</a>
              </span>
          
              <span class="gap-btn">
                <a @click="openSubDetail(record)">查看</a>
              </span>
            </div>

          </div>
        </template>
      </a-table>
      <div class="mt20">
        <a-pagination
        v-model:current="task.page.num"
        show-quick-jumper
        :pageSize=task.page.size
        :total="task.page.total"
        :show-total="total => `共 ${total} 条`"
        @change="getTaskList"
      ></a-pagination>
      </div>
    </a-card>

    <!--  拒绝弹框 -->
    <a-modal v-model:visible="rejectedData.visible" :maskClosable="false" title="拒绝理由">
      <a-textarea v-model:value="rejectedData.reason" placeholder="拒绝原因" :rows="4" />
      <template #footer>
        <a-button key="back" @click="rejectedData.visible = false">取消</a-button>
        <a-button key="submit" type="primary" :loading="rejectedData.loading" @click="taskReject(rejectedData.record)">确认</a-button>
      </template>
    </a-modal>

    <!-- 拆分弹框 -->
    <SplitDialog v-if="splitData.visible" :taskId="splitData.taskId" :number="splitData.number" :name="splitData.name" :total="splitData.detailTotal"  @close="closeSplit"></SplitDialog>

    <!--  指派弹框  -->
    <AssiignDialog v-if="assigndData.visible" :task="assigndData.task"  @close="closeAssign"></AssiignDialog>
  </div>
</template>


<script>
const columns = [
  {
    title: '任务编号',
    dataIndex: 'number'
  },
  {
    title: '任务名称',
    dataIndex: 'name'
  },
  {
    title: '任务类型',
    dataIndex: 'type',
    slots: { customRender: 'taskType' }

  },
  {
    title: '任务状态',
    dataIndex: 'state',
    slots: { customRender: 'taskStatus' }
   

  },
  {
    title: '发布人',
    dataIndex: 'createUserName',

  },

  {
    title: '发布时间',
    dataIndex: 'createTime',
   
  },
  {
    title: '要求完成时间',
    dataIndex: 'endTime',

  },
  {
    title: '操作',
    slots: { customRender: 'action' }

  }
]

import {reactive, onMounted, defineAsyncComponent} from "vue";
import {useRoute, useRouter} from 'vue-router'
import { message } from 'ant-design-vue';
import { useStore } from '@/store/index2'
import {statusToCn} from '@/filters'

import {pageForServer, subSubmit,  labelTaskReceive, labelTaskReject, labelTaskSplit,labelTaskAssign,teamMembers, forView, subForView, otherLabelCompleted} from '@/api/taskRelease'
const SplitDialog = defineAsyncComponent(() => import('./SplitDialog.vue'))
const AssiignDialog = defineAsyncComponent(() => import('./AssiignDialog.vue'))
export default{
  components:{
    SplitDialog,
    AssiignDialog  
  },
  data(){
    return {
      submitLoading:false,
    }
  },
  methods:{
    labelFinished(row){
      if(this.submitLoading) return
      this.submitLoading = true
      otherLabelCompleted(row.id).then(()=>{
        message.success('操作成功')
        this.submitLoading = false
        this.getTaskList()
      }).catch(()=>{
        this.submitLoading = false
      })
    }
  },
  setup(){
    const router = useRouter()
    let task = reactive({
      list:[],
      fromType:'creat',
      page:{
        num:1,
        size:10,
        total:0
      },
      taskData:[]
    })

    //打开详情
   function openDetail(record){
    debugger
    let arr = []
    if(record.children && record.children.length > 0){
      
      record.children.forEach((item)=>{
        arr.push({
          id:item.id,
          number:item.number
        })
      })
      localStorage.setItem('subTask',JSON.stringify(arr))      
      }
      router.push(`/taskDetail?taskId=${record.id}&page=server`)
      
    }


     // 跳转子任务详情
    function openSubDetail(record){
      localStorage.setItem('subTask',JSON.stringify([{id:record.id,number:record.number}]))
      router.push(`/labelDetail?taskId=${record.taskId}&subTaskId=${record.id}&&page=server&type=view`)
    }

    let store = useStore()
    let {taskSatus,subtaskSatus,taskType } = store

    function statusTrans(state, stateObj){
      return statusToCn(state, stateObj)
    }
  

    /*  拆分业务   */
    let splitData = reactive({
      taskId:0,
      show:false,
      number:'',
      name:'',
      detailTotal:0,
      subTotal:0
    })

    async function splitHandle(record){
      debugger
      splitData.taskId = record.id
      splitData.visible = true
      splitData.number = record.number
      splitData.name = record.name



      let params = {
        labelTaskId:record.id
      }
      const {data:res} = await forView(params)
      splitData.detailTotal = res.data.detailTotal
      splitData.subTotal = res.data.subTotal
      //detail.info = {...res.data}

    }

    
    let form = reactive({
      searchForm:{
        takType:'',
        status:'',
        keywords:'',
      }
    })
    
    let optData = reactive({
      taskTypeOpt:[{label:'全部',value:''}],
      taskStatusOpt:[{label:'全部',value:''}],
    })

    /* 拒绝业务 */
    let rejectedData = reactive({
      visible:false,
      loading:false,
      reason:'',
      record:{}
    })

    function rejectHandle(record){
      rejectedData.visible = true
      rejectedData.record = {...record}
    }

    async function taskReject(record){
      rejectedData.loading = true
      let params = {
        labelTaskId:record.id,
        reason:rejectedData.reason,
      }
      const {data:res} = await labelTaskReject(params)
      if(res.code == 0){
        message.success(res.msg)
        rejectedData.visible = false
        getTaskList()
      }else{
        message.success(res.msg)
      }     
      rejectedData.loading = false
    }


    /*  接收业务  */
    async function taskReceive(record){
      let params = {
        labelTaskId:record.id
      }
      const {data:res} = await labelTaskReceive(params)
      if(res.code == 0){
        message.success(res.msg)
        getTaskList()
      }else{
        message.success(res.msg)
      }
    }
    
    

    /*  提交  */
    async function taskSubmit(record){
      debugger
      let params = {
        labelTaskSubId:record.id
      }
      const {data:res} = await subSubmit(params)
      if(res.code == 0){
        message.success(res.msg)
        getTaskList()
      }else{
        message.success(res.msg)
      }
    }
     


    function closeSplit(){
      splitData.visible = false
      getTaskList()
    }


    function closeAssign(){
      assigndData.visible = false
      getTaskList()
    }

    function initData(){
      try {
        for(let prop in taskType){
          optData.taskTypeOpt.push({
            value:prop,
            label:taskType[prop]
          }) 
        }

        for(let prop in taskSatus){
          optData.taskStatusOpt.push({
            value:prop,
            label:taskSatus[prop]
          }) 
        }

      } catch (error) {
        
      }
    }

    //  搜索
    const search = ()=>{
      task.page.num = 1
      getTaskList()
    }

    //  任务列表  
    const getTaskList = async ()=>{
      task.list = []
      let params = {
        groupId:JSON.parse(localStorage.getItem('westCurrentRole')).teamId,
        keyword:form.searchForm.keywords,
        pageNum:task.page.num,
        pageSize:task.page.size,
        state: form.searchForm.status,
        type:form.searchForm.takType,
        //visibility:'',
      }
      const {data:res} = await pageForServer(params)
        const list = [...res.data.records]
        list.forEach((item)=>{
          item.isParent = true
          if(item.children.length == 0){
            delete item.children
          }
        })
        
        task.list = list
        task.page.total = res.data.total

    }


    onMounted(() => {
      getTaskList()
      initData()
    })

    let member = {
      list:[]
    }

     // 获取成员信息
     async function getMember(record){
      let params = {
        labelTaskSubId:record.id,
        inspector:'',
        labeler:''
      }
      const {data:res} = await teamMembers(params)
      if(res.code == 0){
        message.success(res.msg)
        getTaskList()
      }else{
        message.success(res.msg)
      }
     
    }

    

    



    
    /* 指派业务   */
    let assigndData = reactive({
      visible:false,
      loading:false,
      inspector:'',
      inspectorName:'',
      labeler:'',
      labelerName:'',
      name:'',
      task:{}
    })

    async function taskAssignHandle(record){
      assigndData.visible = true
      let params = {
        labelTaskSubId:record.id
      }
      const {data:res} = await subForView(params)
      debugger
      // assigndData.taskId = record.data.taskId
      // assigndData.number = record.data.number
      // assigndData.name = record.data.name
      // assigndData.inspector = record.data.inspector,
      // assigndData.inspectorName = record.data.assigndData,
      // assigndData.labeler = record.data.labeler
      // assigndData.labelerName = record.data.labelerName
      assigndData.task = {...res.data}
    }

    async function taskAssign(record){
      let params = {
        labelTaskSubId:record.id,
        inspector:'',
        labeler:''
      }
      const {data:res} = await labelTaskAssign(params)
      if(res.code == 0){
        message.success(res.msg)
        getTaskList()
      }else{
        message.success(res.msg)
      }
    }

    return{   
      form,
      columns,
      openDetail,
      taskType,
      taskSatus,
      subtaskSatus,
      statusToCn,
      getTaskList,
      task,
      statusTrans,

      optData,
      search,
   
      taskReceive,
      taskReject,

      taskAssignHandle,
      taskAssign,
      rejectedData,
      rejectHandle,
      splitData,
      splitHandle,
      closeSplit,
      assigndData,
      openSubDetail,
      taskSubmit,
      closeAssign,
    }
  }
}
</script>


<style>

</style>
